/**
* Logo Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Logo Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'logo-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      dupeSlider( 'logo-marquee', 'slider', 'slide', false );
      function dupeSlider( sliderContainer, slider, slide, rtl = false ) {
        $( `.${sliderContainer}` ).each( function() {
          const section = $( this );
          const sectionWidth = section.width();
          const doubleSectionWidth = sectionWidth * 2;
          let iterations = 0;
          const maxIterations = 10;
          let totalWidth = 0;
          const slides = section.find( `.${slider} .${slide}` );
          slides.each( function() {
            totalWidth += $( this ).width();
          } );
          while ( totalWidth < doubleSectionWidth && iterations < maxIterations ) {
            if ( totalWidth < doubleSectionWidth ) {
              slides.each( function() {
                // Clone each slide and append it to the marquee-track
                const clonedSlide = $( this ).clone();
                $( `.${sliderContainer} .${slider}` ).append( clonedSlide );
                // Update the total width with the width of the cloned slide
                totalWidth += clonedSlide.width();
              } );
            }
            iterations++;
          }
          if ( rtl ) {
            $( this ).find( `.${slider}` ).slick( {
              speed: 5000,
              autoplay: true,
              autoplaySpeed: 0,
              cssEase: 'linear',
              slidesToShow: 5,
              slidesToScroll: 1,
              infinite: true,
              arrows: false,
              buttons: false,
              dots: false,
              variableWidth: true,
              rtl: true,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                  },
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                  },
                },
              ],
            } );
          } else {
            $( this ).find( `.${slider}` ).slick( {
              dots: false,
              arrows: false,
              pauseOnHover: false,
              pauseOnFocus: false,
              autoplay: true,
              infinite: true,
              slidesToShow: 5,
              slidesToScroll: 1,
              autoplaySpeed: 0,
              speed: 5000,
              variableWidth: true,
              cssEase: 'linear',
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                  },
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                  },
                },
              ],
            } );
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'logo-marquee', COMPONENT );
} )( app );
